
import axios from "axios";
import ICategory from "../entities/ICategory";
import ICategoryVariant, { ICategoryVariantOption } from "../entities/ICategoryVariant";
import Axios from "./Axios";
import { get } from "./HttpApi";
import { unwrapList } from "./apiUtils";
import ENDPOINTS from "./endpoints";

const normalizeVariant = (raw: any): ICategoryVariant => ({
  categoryVariantId: raw?.categoryVariantId ?? 0,
  categoryId: raw?.categoryId ?? raw?.category?.categoryId ?? 0,
  variantName: raw?.variantName ?? "",
  displayOrder: raw?.displayOrder ?? 1,
  isRequired: raw?.isRequired ?? 1,
  isActive: raw?.isActive ?? 1,
  categoryVariantOptionList: Array.isArray(raw?.categoryVariantOptionList)
    ? raw.categoryVariantOptionList.map(normalizeVariantOption)
    : [],
});

const normalizeVariantOption = (raw: any): ICategoryVariantOption => ({
  categoryVariantOptionId: raw?.categoryVariantOptionId ?? 0,
  categoryVariantId: raw?.categoryVariantId ?? raw?.categoryVariant?.categoryVariantId,
  optionValue: raw?.optionValue ?? "",
  displayOrder: raw?.displayOrder ?? 1,
  isActive: raw?.isActive ?? 1,
});

const getAll = async () : Promise<Array<ICategory>> => {
    return await get(ENDPOINTS.categories.all).then(res => {
          const data = res;
          return data;
        });

  };

  async function getAllCategory() {

    return new Promise((resolve) =>  {
      setTimeout(() => resolve(get(ENDPOINTS.categories.all)), 200);
    });
  }

  const getCategory = () =>{
    return Axios.get<Array<ICategory>>(ENDPOINTS.categories.all) ;
  }

  const getParentCategory = () =>{
    return Axios.get<Array<ICategory>>(ENDPOINTS.categories.parentOnly) ;
  }

  const createCategory = (data: ICategory)=> {
    return Axios.post<ICategory>(ENDPOINTS.categories.create, data);
  }

  const updateCategory = (id: number, data: ICategory) => {
    return Axios.put<ICategory>(ENDPOINTS.categories.update(id), data);
  }

  const deleteCategory = (id: number) => {
    return Axios.delete(ENDPOINTS.categories.delete(id));
  }

  const getCategoryById = (id: number) => {
    return Axios.get<ICategory>(ENDPOINTS.categories.byId(id));
  };

  const getCategoryVariants = async (categoryId: number): Promise<Array<ICategoryVariant>> => {
    const res: any = await Axios.get(ENDPOINTS.categoryVariants.byCategoryId(categoryId));
    const list = unwrapList<any>(res);
    return list.map(normalizeVariant);
  };

  const addCategoryVariant = (
    categoryId: number,
    variantName: string,
    displayOrder: number = 1,
    isRequired: boolean = true
  ) => {
    return Axios.post(ENDPOINTS.categoryVariants.create, {
      category: { categoryId },
      variantName,
      displayOrder,
      isRequired: isRequired ? 1 : 0,
      isActive: 1,
    });
  };

  const updateCategoryVariant = (variant: ICategoryVariant) => {
    return Axios.put(ENDPOINTS.categoryVariants.update(variant.categoryVariantId), {
      categoryVariantId: variant.categoryVariantId,
      variantName: variant.variantName,
      displayOrder: variant.displayOrder,
      isRequired: variant.isRequired,
      isActive: variant.isActive,
    });
  };

  const deleteCategoryVariant = (categoryVariantId: number) => {
    return Axios.delete(ENDPOINTS.categoryVariants.delete(categoryVariantId));
  };

  const addCategoryVariantOption = (
    categoryVariantId: number,
    optionValue: string,
    displayOrder: number = 1
  ) => {
    return Axios.post(ENDPOINTS.categoryVariantOptions.create, {
      optionValue,
      displayOrder,
      isActive: 1,
      categoryVariant: { categoryVariantId },
    });
  };

  const deleteCategoryVariantOption = (categoryVariantOptionId: number) => {
    return Axios.delete(ENDPOINTS.categoryVariantOptions.delete(categoryVariantOptionId));
  };

  const updateCategoryVariantOption = (
    categoryVariantOptionId: number,
    categoryVariantId: number,
    optionValue: string,
    displayOrder: number = 1
  ) => {
    return Axios.put(ENDPOINTS.categoryVariantOptions.update(categoryVariantOptionId), {
      categoryVariantOptionId,
      optionValue,
      displayOrder,
      isActive: 1,
      categoryVariant: { categoryVariantId },
    });
  };

  const CategoryService = {
    getAll,
    get,
    getAllCategory,
    createCategory,
    updateCategory,
    deleteCategory,
    getCategoryById,
    getCategory,
    getParentCategory,
    getCategoryVariants,
    addCategoryVariant,
    updateCategoryVariant,
    deleteCategoryVariant,
    addCategoryVariantOption,
    updateCategoryVariantOption,
    deleteCategoryVariantOption,

  };

  export default CategoryService;